import React, { FC, useEffect, useState } from 'react';

interface IInput {
    label?: string;
    type?: string;
    name: string;
    placeholder: string;
    error?: string;
    value?: string;
    setFormData: (state: any) => void;
    setErrors?: (state: any) => void;
    style?: any;
    lockedText?: null | string;
    disabled?: boolean;
    isReset?: boolean;
}

const Input: FC<IInput> = ({
    label,
    type,
    name,
    placeholder,
    setFormData,
    error,
    setErrors,
    value,
    lockedText,
    style,
    isReset,
    disabled = false}): React.ReactElement => {

    const [ input, setInput ] = useState<string | undefined>('');
    const [ types, setTypes ] = useState<string>(type ?? 'text');
    const [ eye, setEye ] = useState<boolean>(false);
    const [locked, setLocked] = useState<string>('');

    useEffect(() => {
        if (!lockedText) return;
        const str = lockedText + '\n\n';
        setLocked(str);
        setInput(str);
    }, [lockedText]);

    useEffect(() => {
        setInput(isReset ? '' : value);
    }, [value, isReset]);

    const onChangeHandler = (e: any) => {
        e.persist();
        const {value} = e.target
        if (lockedText && !value.includes(locked)) return;

        setInput(value);

        type === 'password' && setEye(false);

        setFormData((state: any) => ({...state, [name]: value}));
        setErrors && setErrors((state: any) => ({...state, [name]: ''}));
    };

    useEffect(() => {
        type === 'password' && setTypes(eye ? 'text' : 'password');
    }, [eye]);

    const eyeHandler = () => setEye(!eye);

    if (type === 'textarea')
        return (
            <div className='input' style={style || {}}>
                {label ? <label className='input__label' htmlFor={name}>{label}</label> : <></>}

                <textarea
                    className={`input__textarea${error ? ' input__textarea--error' : ''}`}
                    onChange={onChangeHandler}
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    value={input ?? ''}
                />

                {error ? <div className='input__error'>{error}</div> : <></>}
            </div>)

    return (
        <div className='input'>
            {label ? <label className='input__label' htmlFor={name}>{label}</label> : <></>}

            <input
                onChange={onChangeHandler}
                className={`input__body${error ? ' input__body--error' : ''}`}
                placeholder={placeholder}
                name={name}
                value={input ?? ''}
                type={types}
                disabled={disabled}
            />

            {type === 'password'
                ? <div onClick={eyeHandler} className='input__body-eye'>
                    <img src={`/images/pages/Directory/eye-${eye ? 'open' : 'close'}.svg`} alt="Login"/>
                </div>
                : <></>}

            {error ? <div className='input__error'>{error}</div> : <></>}
        </div>)
}

export default Input
